import { render, staticRenderFns } from "./ClubRoom.vue?vue&type=template&id=66bbe2a6&scoped=true&"
import script from "./ClubRoom.vue?vue&type=script&lang=js&"
export * from "./ClubRoom.vue?vue&type=script&lang=js&"
import style0 from "./ClubRoom.vue?vue&type=style&index=0&id=66bbe2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbe2a6",
  null
  
)

export default component.exports